import { useState, useEffect, useCallback } from "react";

const STORAGE_KEY = "datacom.sidebar.collapsed";
const LEGACY_KEYS = [
  "sidebar.open",
  "sidebar",
  "datacom.sidebar",
  "datacom.sidebarOpen",
];

function readInitialOpen(): boolean {
  if (typeof window === "undefined") return false;
  try {
    LEGACY_KEYS.forEach((k) => localStorage.removeItem(k));
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === null) return false;
    return stored === "false";
  } catch {
    return false;
  }
}

export function useSidebar() {
  const [open, setOpen] = useState<boolean>(readInitialOpen);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, String(!open));
    } catch { /* storage non disponibile: il menu torna aperto al riavvio */ }
  }, [open]);

  const toggle = useCallback(() => {
    setOpen((prev) => !prev);
  }, []);

  return { open, setOpen, toggle };
}